import { useStoreId } from '@moonpig/web-core-stores'
import React, { FC, useRef } from 'react'
import { Image } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { useProductModal } from '../../../contexts/productModal'
import { AddedToBasketEvent } from '../../../types'
import { SearchServiceProductFragment as Product } from '../query/__generated__/moreLikeThis'
import { CARD_WIDTH } from '../constants'

const StyledLink = styled.a`
  display: flex;

  ${s({
    p: 2,
    maxWidth: `${CARD_WIDTH}px`,
    height: '100%',
    alignItems: 'end',
  })}
`

const StyledImage = styled(Image)`
  width: 100%;
  ${s({
    boxShadow: 2,
  })}
`

type Props = {
  product: Product
  index: number
  onAddToBasket: (addedEvent: AddedToBasketEvent) => void
}

export const SimpleCardTile: FC<Props> = ({
  product,
  index,
  onAddToBasket,
}) => {
  const {
    id,
    category: { slug: categorySlug },
    slug,
  } = product
  const region = useStoreId()
  const { show } = useProductModal()
  const productTileRef = useRef<HTMLAnchorElement>(null)

  const productDetailsURL = `/${region}/${categorySlug}/p/${slug}/${id.toLowerCase()}/`

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    show({
      triggerElementRef: productTileRef,
      index,
      product,
      configuration: {
        showProductTabs: false,
        showStickyCta: false,
      },
      onAddToBasket,
    })
  }

  return (
    <StyledLink
      key={product.id}
      ref={productTileRef}
      href={productDetailsURL}
      onClick={handleClick}
      aria-label={product.title}
    >
      <StyledImage
        src={
          product.masterVariant.images?.[0]?.url ||
          /* istanbul ignore next */
          product.masterVariant.masterImage?.url ||
          /* istanbul ignore next */
          ''
        }
        alt={product.title}
      />
    </StyledLink>
  )
}
